  <template>
  <div class="broadcastbbs infoPub">
    <el-col class="infoPub" style="width: 990px">
      <div class="total-data" v-if="userInfo.user_admin_state == 1">
        <span>{{language.bbsForumAccount}}：{{totalData.bbs_count}}</span>
        <span>{{language.bbsForumLive}}：{{totalData.play_count}}</span>
        <span>{{language.bbsForumNowNum}}：{{totalData.user_count}}</span>
      </div>
      <!-- 搜索组件 -->
      <search-bar
        :selectType="ExhIndexType"
        :searchInputPlc="language.fairName"
        :searchSelectPlc="language.exhibitionState"
        @changeExhibitionState="toSearch"
        @toSearch="toSearch"
      ></search-bar>

      <!-- 列表组件 -->
      <bbs-list
        :listData="cloneListData"
        @editData="editData"
        @joinData="joinData"
        @showImg="showImg"
        v-loading="loading"
        :language="language"
      ></bbs-list>
      <!-- page -->
      <table-page
        :pageSize="pageSize"
        :layout="layout"
        :pageTotal="pageTotal"
        :currentPage="currentPage"
        @pageChange="pageChange"
      ></table-page>
    </el-col>

    <!-- 修改弹窗 -->
    <dialog-pub
      exTop="8vh"
      ref="dialogChild"
      class="bbsdialog"
      :title="title"
      :dialogFormVisible="dialogFormVisible"
    >
      <el-form :model="form">
        <el-form-item :label="language.bbsThemeCh+':'" :label-width="formLabelWidth">
          <el-input style="width:369px" v-model="form.broadcast_name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="language.bbsThemeEn+':'" :label-width="formLabelWidth">
          <el-input style="width:369px" v-model="form.broadcast_name_en" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="language.compereCh+':'" :label-width="formLabelWidth">
          <el-input style="width:369px" v-model="form.truename" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="language.compereEn+':'" :label-width="formLabelWidth">
          <el-input style="width:369px" v-model="form.truename_en" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="language.bbsVisitor+language.chineseName+':'" :label-width="formLabelWidth">
          <el-input
            style="width:369px"
            v-model="form.user_post"
            :placeholder="language.segmentation"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item :label="language.bbsVisitor+language.englishName+':'" :label-width="formLabelWidth">
          <el-input
            style="width:369px"
            v-model="form.user_post_en"
            :placeholder="language.segmentation"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item :label="language.bbsTimeCh+':'" :label-width="formLabelWidth">
          <el-input v-model="form.location" style="width:369px">
            <!-- <i slot="prefix" class="el-input__icon el-icon-date"></i> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="language.bbsTimeEn+':'" :label-width="formLabelWidth">
          <el-input v-model="form.location_en" style="width:369px">
            <!-- <i slot="prefix" class="el-input__icon el-icon-date"></i> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="language.introductionCh+':'" :label-width="formLabelWidth">
          <el-input
            style="width:369px"
            type="textarea"
            v-model="form.broadcast_introduce"
            :placeholder="language.introduction"
          ></el-input>
        </el-form-item>
        <el-form-item :label="language.introductionEn+':'" :label-width="formLabelWidth">
          <el-input
            style="width:369px"
            type="textarea"
            v-model="form.broadcast_introduce_en"
            :placeholder="language.introduction"
          ></el-input>
        </el-form-item>

        <el-form-item :label="language.companyLogo+':'" :label-width="formLabelWidth">
          <el-upload
            action="https://exhxcx.shippingchina.com/api.php/Home/Publicother/uploadpic"
            class="uploadImg"
            list-type="picture-card"
            :on-success="updateSuccess"
            :before-upload="onBeforeUpload"
            :on-remove="handleRemove"
            :on-preview="handlePictureCardPreview"
            :limit="1"
            :file-list="imgList"
            accept=".jpg, .jpeg, .png, .JPG, .JPEG, .gif, .bmp, .BMP, .PNG"
          >
            <div class="upText">
              <div>{{language.click}}</div>
              <div>{{language.uploadLogo}}</div>
            </div>
          </el-upload>
          <div
            style="font-size:12px;color:#424242;padding-left:11px"
          >{{language.suggestSize}}670*150px</div>
        </el-form-item>

        <el-form-item :label="language.applentLogo+':'" :label-width="formLabelWidth">
          <el-upload
            action="https://exhxcx.shippingchina.com/api.php/Home/Publicother/uploadpic"
            class="uploadImg"
            list-type="picture-card"
            :on-success="updateApplentSuccess"
            :before-upload="onBeforeUpload"
            :on-remove="handleRemoveApplent"
            :on-preview="handleApplentPictureCardPreview"
            :limit="1"
            :file-list="broadcast_applent_logo_imgList"
            accept=".jpg, .jpeg, .png, .JPG, .JPEG, .gif, .bmp, .BMP, .PNG"
          >
            <div class="upText">
              <div>{{language.click}}</div>
              <div>{{language.uploadLogo}}</div>
            </div>
          </el-upload>
          <div
            style="font-size:12px;color:#424242;padding-left:11px"
          >{{language.suggestSize}}750*600px</div>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="formBtn" @click.native="ok">{{language.confirm}}</el-button>
        <el-button class="formBtn" type="primary" @click.native="cancel">{{language.cancel}}</el-button>
      </div>
    </dialog-pub>
    <!-- 查看大图 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="form.broadcast_logo" alt />
    </el-dialog>
    <el-dialog :visible.sync="dialogDroadcastApplentLogoVisible">
      <img width="100%" :src="form.broadcast_applent_logo" alt />
    </el-dialog>


    <!-- 邀请码图片展示 -->

    <!-- <dialog-pub
      ref="dialogChild"
      class="dislogCon"
      exTop="8vh"
      title="邀请码分享"
      :dialogFormVisible="dialogFormVisible"
      style="text-align:center; margin:0 auto;"
    >
      <img :src="imgSrc" alt="">
      <div class="dialog-footer">
        <el-button class="formBtn" @click.native="imgDown">下载</el-button>
        <el-button class="formBtn" type="primary" @click.native="cancel">取消</el-button>
      </div>
    </dialog-pub> -->


    <!-- 邀请码分享 -->
    <el-dialog
        title=""
        :visible.sync="showImgDialogFormVisible"
        width="1200px"
        top="10vh"
        class="dislogCon-Img"  style="margin: 0 auto;text-align:center;">
        <!-- <img :src="imgSrc" alt="" style="margin: 0 auto;text-align:center;"> -->
        <div class="img-wrap">
            <div class="img-wrap-left">
                <img class="choose-img" :src="imgSrcList[imgSrcIndex]" alt="">
            </div>
            <div class="img-wrap-right">
                <div class="img-wrap-title">
                    <p>制作手机海报分享</p>
                    <div class="div-border-bottom-color"></div>
                </div>
                <div class="img-wrap-right-top">
                    <div :class="imgSrcIndex == index ? 'img-wrap-right-top-div img-wrap-right-top-div-active' : 'img-wrap-right-top-div' " v-for="(item, index) in imgSrcList" :key="index">
                        <img :src="item" alt="" @click="changeImgSrc(index)">
                        <img v-if="imgSrcIndex == index" class="img-right" src="../../../assets/icon-right.png" alt="">
                    </div>
                </div>
                <div class="img-formBtn">
                    <el-button class="img-down-formBtn" @click.native="imgDown">下载</el-button>
                    <el-button class="img-camcale-formBtn" type="primary" @click.native="cancelImg">取消</el-button>
                </div>
            </div>
        </div>
    </el-dialog>

    <download-dialog :show.sync="downloadShow" />
  </div>
</template>
<script>
import reqest from "@/common/reqest";
import { language } from "../../../language/get";
import { ExhIndexType } from "../../../common/constant/exhibition";
import Cookie from "../../../common/cookie";
import searchBar from "../components/searchbar/searchbar";
import bbsList from "../components/bbslist/bbslist";
import tablePage from "../components/tablepage/tablepage";
import { isEmpty, isInternet } from "../../../common/validate";
import { roomUrl, windowsGoTo } from "../../../common/url";
import dialogPub from "../components/dialogpub/dialogpub";
import {MessageBox} from 'element-ui';
const pubLanguage = language();
import downloadDialog from "../../../components/DownloadDialog/index";
import {
  getBroadcastList,
  getBroadcastClass,
  editBroadcastList,
  BbsCountTotal,
} from "../../../api/btManage";
import { mapGetters } from "vuex";
import { getLiveUrl } from "../../../api/forum";
import axios from "axios";

const initialization = {
  broadcast_id: "",
  broadcast_class_id: "",
  broadcast_name: "",
  broadcast_name_en: "",
  location: "",
  location_en: "",
  broadcast_name1: "",
  user_post: "",
  user_post_en: "",
  truename: "",
  truename_en: "",
  broadcast_class_name: "",
  tel: "",
  broadcast_introduce: "",
  broadcast_introduce_en: "",
  broadcast_logo: null,
  broadcast_applent_logo: null
};
export default {
  components: {
    searchBar,
    bbsList,
    tablePage,
    downloadDialog,
    dialogPub
  },
  computed: {
    ...mapGetters(["token", "userInfo"])
  },
  data() {
    return {
      loading: "true",
      downloadShow: false,
      ExhIndexType,
      //弹窗
      title: pubLanguage.editeStudio,
      //图片上传
      dialogVisible: false,
      dialogDroadcastApplentLogoVisible: false,
      imgList: [],
      broadcast_applent_logo_imgList: [],
      dialogFormVisible: false,
      form: { ...initialization },
      formLabelWidth: "20%",
      language: language(),
      lan: Cookie.get("lang"),
      broadClass: [],
      listData: [],
      cloneListData: [],
      //page
      pageTotal: 0,
      pageSize: 2,
      currentPage: 1,
      layout: "prev, pager, next, jumper",
      //搜索条件
      getStateCon: null,
      getValCon: null,
      totalData: {
        bbs_count: "0",
        play_count: "0",
        user_count: "0"
      },

      showImgDialogFormVisible:false,
      imgSrcList: [],
      imgSrcIndex: 0,

    };
  },
  created() {
    //this.broadcastClass();
  },
  mounted() {
    let comfirmData = {
      token: this.$store.state.user.token
    };
    console.log(comfirmData);
    BbsCountTotal(comfirmData)
      .then(res => {
        if (res.type == "1") {
          this.totalData = res.data[0];
        } else {
          if (this.lan == "ch") {
            const height = document.body.clientHeight / 2;
            return this.$message.error({ message: res.text, offset: height });
          }
          return this.$message.error({ message: res.text_en, offset: 120 });
        }
      })
      .catch(() => {});
  },
  methods: {
    //update
    onBeforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isLt1M) {
        const height = document.body.clientHeight / 2;
        this.$message({
          showClose: true,
          message: this.language.fileMaxSize,
          type: "error",
          offset: height
        });
      }
      return isLt1M;
    },
    updateSuccess(res) {
      this.form.broadcast_logo = res.data.file.picurl;
    },
    updateApplentSuccess(res) {
      this.form.broadcast_applent_logo = res.data.file.picurl;
    },
    handleRemove() {
      this.form.broadcast_logo = "";
    },
    handleRemoveApplent() {
      this.form.broadcast_applent_logo = "";
    },
    handlePictureCardPreview(file) {
      this.form.broadcast_logo = file.url;
      this.dialogVisible = true;
    },
    handleApplentPictureCardPreview(file) {
      this.form.broadcast_applent_logo = file.url;
      this.dialogDroadcastApplentLogoVisible = true;
    },
    //修改赋值
    editData(id) {
      this.$refs.dialogChild.receiveDialogFormVisible = true;
      let editDataList = this.listData.find(item => {
        return item.broadcast_id === id;
      });
      // editDataList.user_post.toString().replace(/,/g,";")
      for (let editDataListKey in editDataList) {
        for (let formKey in this.form) {
          if (editDataListKey === formKey) {
            this.form[formKey] = editDataList[editDataListKey];
          }
        }
      }
      if (
        this.form.broadcast_logo != null &&
        !isEmpty(this.form.broadcast_logo)
      ) {
        this.imgList = [{ status: "success", url: this.form.broadcast_logo }];
      } else {
        this.imgList = [];
      }
      if (
        this.form.broadcast_applent_logo != null &&
        !isEmpty(this.form.broadcast_applent_logo)
      ) {
        this.broadcast_applent_logo_imgList = [{ status: "success", url: this.form.broadcast_applent_logo }]
      } else {
        this.broadcast_applent_logo_imgList = []
      }
      this.dialogFormVisible = true;
    },
    //取消/关闭
    cancel() {
      this.form = { ...initialization };
      this.$refs.dialogChild.receiveDialogFormVisible = false;
    },
    //确认修改
    ok() {
      this.editBroadcastList();
    },
    editBroadcastList() {
      let data = {
        lan: this.lan,
        token: this.$store.state.user.token,
        broadcast_id: this.form.broadcast_id,
        broadcast_name: this.form.broadcast_name,
        broadcast_name_en: this.form.broadcast_name_en,
        broadcast_introduce: this.form.broadcast_introduce,
        broadcast_introduce_en: this.form.broadcast_introduce_en,
        user_post: this.form.user_post,
        user_post_en: this.form.user_post_en,
        truename: this.form.truename,
        truename_en: this.form.truename_en,
        location: this.form.location,
        location_en: this.form.location_en,
        broadcast_class_id: this.form.broadcast_class_id,
        broadcast_logo: this.form.broadcast_logo,
        broadcast_applent_logo: this.form.broadcast_applent_logo
      };
      editBroadcastList(data)
        .then(res => {
          const height = document.body.clientHeight / 2;
          if (res.type == "1") {
            this.$message({
              showClose: true,
              message: this.language.editSuccess,
              type: "success",
              offset: height
            });
            this.$refs.dialogChild.receiveDialogFormVisible = false;
            this.getList();
            this.form = { ...initialization };
          } else {
            if (this.lan == "ch") {
              return this.$message.error({ message: res.text, offset: height });
            }
            return this.$message.error({ message: res.text_en, offset: height });
          }
        })
        .catch(() => {});
    },
    //分页
    pageChange(val) {
      this.currentPage = val;
      this.getList();
    },
    //搜索切换
    toSearch(state, val) {
      this.getStateCon = state;
      this.getValCon = val;
      this.currentPage = 1;
      this.getList();
    },
    //获取直播间分类
    broadcastClass() {
      getBroadcastClass({exhibition_id:""}).then(res => {
        if (res.type != "1") {
          if (this.lan == "ch") {
            const height = document.body.clientHeight / 2;
            return this.$message.error({ message: res.text, offset: height });
          }
          return this.$message.error({ message: res.text_en, offset: 120 });
        }
        const data = res.data;
        data.splice(0, 0, {
          broadcast_class_id: "",
          broadcast_class_name: "全部",
          broadcast_class_name_en: "All"
        });
        this.broadClass = data;
      });
    },
    getList() {
      let that = this;
      let data = {
        token: this.$store.state.user.token,
        broadcast_type: "2",
        broadcast_class_id: this.getStateCon,
        keyword: this.getValCon,
        currentPage: this.currentPage,
        numberPage: this.pageSize
      };
      getBroadcastList(data).then(res => {
        if (res.type == "1") {
          if (!res.data) {
            this.listData = [];
            this.cloneListData = [];
            this.pageTotal = res.datacount;
            this.loading = false;
            return false;
          }
          res.data.forEach(item => {
             if (this.lan == "en") {
              item.exh_name = `${item.exh_name_en}`;
              item.exh_begtime = `${item.exh_begtime_en}`;
              item.exh_endtime = `${item.exh_endtime_en}`;
              item.broadcast_name = `${item.broadcast_name_en}`;
              item.broadcast_introduce = `${item.broadcast_introduce_en}`;
              item.location = `${item.location_en}`;
              item.user_post = `${item.user_post_en}`;
              item.truename = `${item.truename_en}`;
            }
            if (item.user_post) {
              let names = item.user_post;
              for (let name of names) {
                if (
                  !(
                    (name >= "A" && name <= "Z") ||
                    (name >= "a" && name <= "z") ||
                    (name >= "\u4e00" && name <= "\u9fa5") ||
                    (!isNaN(name) &&
                      name != name.replace(/(^\s*)|(\s*$)/g, "") &&
                      name.replace(/(^\s*)|(\s*$)/g, "").length != 0)
                  )
                ) {
                  item.userPosts = item.user_post.split(name);
                }
              }
            }
            if (this.lan == "en") {
              item.location = `${item.location_en}`;
            }
            item.periodTime = item.location;
          });
          this.listData = res.data;
          this.cloneListData = res.data;
          this.loading = false;
          this.pageTotal = res.datacount;
        } else {
          if (this.lan == "ch") {
            const height = document.body.clientHeight / 2;
            return this.$message.error({ message: res.text, offset: height });
          }
          return this.$message.error({ message: res.text_en, offset: 120 });
        }
      });
    },
    //进入
    joinData(id) {
      if (!isInternet()) {
        return (this.downloadShow = true);
      }
      const props = {
        token: this.token,
        broadcast_id: id
      };
      getLiveUrl(props).then(res => {
        if (res.type == 11){
          MessageBox({
            title: "",
            message: Cookie.get("lang")=='ch'?res.text:res.text_en,
            confirmButtonText: language().confirm,
            cancelButtonText: language().cancel,
            showCancelButton: false,
            // type: 'success'
          }).then(() => {
            //确认
          }).catch(() => {
            //取消
          });
        } else if (res.type != "1") {
          if (this.lan == "ch") {
            const height = document.body.clientHeight / 2;
            return this.$message.error({ message: res.text, offset: height });
          }
          return this.$message.error({ message: res.text_en, offset: 120 });
        }
        const data = res.data[0];
        sessionStorage.setItem('userType', res.prcurl);
        // console.log(data);
        // return;
        let name = Cookie.get("lang") == 'ch' ? (this.userInfo.true_name || this.userInfo.true_name_en) : (this.userInfo.true_name_en || this.userInfo.true_name);
        return (window.location.href =
          windowsGoTo() + roomUrl(data, name));
      });
    },


    // 邀请码分享
    showImg(e){
        // console.log(e);
        // return;
        let data = {
            exhibition_id: e.exhibition_id,
            broadcast_id: e.broadcast_id,
            currentTab: '1',
        };
        const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        axios.post(reqest.adminapi+'MakeQr/getExhibitionRr',
        // axios.post('http://exhixcx.shippingchina.com/adminapi.php/Home/MakeQr/getExhibitionRr',
            data,
            {}).then(res => {
                loading.close();
                if (res.data.type == "1") {

                    // this.imgSrc = res.data.data.qr_base64;
                    this.imgSrcList = res.data.data.img;
                    this.showImgDialogFormVisible = true;
            // this.$refs.dialogChild.receiveDialogFormVisible = true;
                    // console.log(res.data.data.qr_base64,'eeeeeee')
                } else {

                    if (this.lan == "ch") {
                      const height = document.body.clientHeight / 2;
                    return this.$message.error({ message: res.text, offset: height });
                    }
                    return this.$message.error({ message: res.text_en, offset: 120 });
                }
            })
            .catch((e) => {
                console.log(e);
            });
    },
    changeImgSrc(index){
        this.imgSrcIndex = index;
    },

    showParticipants(e){
        console.log(e);
        const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        let data = {
            token: this.token,
            room_id: e.broadcast_id,
        };
        //获取直播间分类
        liveRoomLine(data).then(res => {
            loading.close();
            if (res.type != "1") {
                if (this.lan == "ch") {
                  const height = document.body.clientHeight / 2;
                  return this.$message.error({ message: res.text, offset: height });
                }
                return this.$message.error({ message: res.text_en, offset: 120 });
            }
            this.participantsBool = false;
            let newResData = e;
            newResData.broadcast_state = res.data.status;
            newResData.is_wait = res.data.is_wait;
            newResData.to_wait = res.data.to_wait;
            newResData.privateTalk = res.data.privateTalk;
            this.$nextTick(()=>{
                this.participants = newResData;
                this.participantsBool = true;
                this.$forceUpdate()
            });
            this.showParticipantsDialogFormVisible = true;
        });
    },

    // 跨域文件下载
    downloadIamge(url, fileName) {

        url= url.replace(/\\/g, '/');
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        //xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
        xhr.onload = () => {
            if (xhr.status == 200) {

                let data = xhr.response;
                let name = fileName;

                var urlObject = window.URL || window.webkitURL || window;
                var export_blob = new Blob([data]);
                var save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a')
                save_link.href = urlObject.createObjectURL(export_blob);
                save_link.download = name;
                save_link.click();

            }
        };

        xhr.send();
    },
    imgDown(){
        // this.downloadIamge(this.imgSrcList[this.imgSrcIndex], 'pic.jpg')
        location.href = "https://exhxcx.shippingchina.com/api.php/Home/Pub/downloadfile?file_path="+this.imgSrcList[this.imgSrcIndex];
    },

    // imgDown(){
    //     var alink = document.createElement("a");
    //     alink.href = this.imgSrcList[this.imgSrcIndex];
    //     alink.download = "pic.jpg"; //图片名
    //     alink.click();
    //     this.showImgDialogFormVisible = false;
    // },


    cancelImg(){
        this.showImgDialogFormVisible = false;
    },

  }
};
</script>
  <style>
.bbsdialog .el-dialog {
  max-height: none;
}
.el-upload-list--picture-card .el-upload-list__item-status-label i {
  margin-top: 6px;
}
.bbsdialog .el-dialog__header {
  position: relative;
}
.bbsdialog .el-dialog__headerbtn {
  top: 4px;
}
.total-data {
  background: #ffffff;
  font-size: 18px;
  color: #434343;
  padding: 14px 10px;
}
.total-data > span {
  margin-right: 40px;
}
.dislogCon{
  text-align: center;
}
.img-formBtn{
  text-align: right !important;
  margin-top: 20px !important;
  margin-right: 20px !important;
}
.img-down-formBtn{
    background: #ff9e00 !important;
    width: 100px !important;
    height: 40px !important;
    color: #ffffff !important;
    border: none !important;
    font-size: 18px !important;
}
.img-camcale-formBtn{
    background: #cccccc !important;
    width: 100px !important;
    height: 40px !important;
    color: #ffffff !important;
    border: none !important;
    font-size: 18px !important;
}


    .img-wrap{
        width: 100%;
        padding: 20px 0;
        display: flex;
    }
    .img-wrap-left{
        flex: 1;
        padding: 20px;
        border-radius: 20px;
        min-height: 500px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #ececec;
    }
    .choose-img{
        width: 300px;
        text-align: center;
        margin: 0 auto;
    }
    .img-wrap-right{
        flex: 2.5;
        margin: 0 auto;
        padding-top: 20px;
    }
    .img-wrap-right-top{
        display: inline-block;
        margin-top: 20px;
    }
    .img-wrap-right-top img{
        width: 150px;
    }
    .img-wrap-right-top-div{
        /* display: inline-block; */
        float: left;
        height: 290px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: 3px solid #ececec;
        margin: 0 10px;
        position: relative;
    }
    /* .img-right{
        display: none;
    } */
    .img-right{
        position:absolute;
        right: 0;
        bottom: 0;
        padding: 0 !important;
        width: 30px !important;
        height: 30px;

    }
    .img-wrap-right-top-div img{

        padding: 20px 10px;
    }
    .img-wrap-right-top-div-active{
        border: 3px solid #ff9e00;
    }
    .img-wrap-title{
        width: 150px;
        margin: 0 auto;
        position: relative;
        z-index: 9;
    }
    .img-wrap-title p{
        color: #212c67;
        font-size: 1.3rem;
        z-index: 9;
    }
    .div-border-bottom-color{
        width: 150px;
        height: 3px;
        background: #c7d0f2;
        position: absolute;
        left: 0;
        bottom: 1px;
        z-index: -1;
    }
    .pc-url-div{
        margin: 60px auto 50px;
        /* width: 500px; */
        height: 80px;
        line-height: 80px;
        border-radius: 10px;
        background: #ececec;
        color: #000;
        display: inline-flex;
        align-content: center;
        justify-content: center;
        padding: 0 50px;
        /* margin: 0 auto; */
    }

    .url-formBtn{
        margin: 0 auto;
        text-align: center;
        /* margin-top: 30px;
        margin-right: 20px; */
    }
    .pc-url-formBtn{
        background: #ff9e00;
        width: 100px;
        height: 40px;
        color: #ffffff;
        border: none;
        font-size: 18px;
    }

</style>
